var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3.0791V6.8291H3.75V3.8291H6.75V2.3291H3C2.80109 2.3291 2.61032 2.40812 2.46967 2.54877C2.32902 2.68942 2.25 2.88019 2.25 3.0791ZM15.75 6.8291V3.0791C15.75 2.88019 15.671 2.68942 15.5303 2.54877C15.3897 2.40812 15.1989 2.3291 15 2.3291H11.25V3.8291H14.25V6.8291H15.75ZM14.25 14.3291H11.25V15.8291H15C15.1989 15.8291 15.3897 15.7501 15.5303 15.6094C15.671 15.4688 15.75 15.278 15.75 15.0791V11.3291H14.25V14.3291ZM6.75 15.8291V14.3291H3.75V11.3291H2.25V15.0791C2.25 15.278 2.32902 15.4688 2.46967 15.6094C2.61032 15.7501 2.80109 15.8291 3 15.8291H6.75ZM1.5 8.3291H16.5V9.8291H1.5V8.3291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrscan);
export default __webpack_public_path__ + "static/media/qrscan.fbed2084070d5a9e2b96347434a1b6db.svg";
export { ForwardRef as ReactComponent };